import { render, staticRenderFns } from "./CommunePage.vue?vue&type=template&id=050e34b1"
import script from "./CommunePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommunePage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CommunePage.vue?vue&type=style&index=0&id=050e34b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports